import React from "react";

/**
 * @ignore - internal component.
 */
export default React.createContext({});
